import { render, staticRenderFns } from "./LangChip.vue?vue&type=template&id=46defe20&scoped=true&"
import script from "./LangChip.vue?vue&type=script&lang=js&"
export * from "./LangChip.vue?vue&type=script&lang=js&"
import style0 from "./LangChip.vue?vue&type=style&index=0&id=46defe20&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46defe20",
  null
  
)

export default component.exports